module.exports = __webpack_public_path__ + "static/media/(V)-Moda-Feminina-Acessorios.b76f58c6.jpg";